import api from './api';

// Sessiemodus: de sessie waarmee de auditor bezig is, per audit onthouden in de
// browser. De controllijst en vorige/volgende op de bevindingspagina volgen ze.

const key = (auditId) => `audit-session-${auditId}`;

export function getActiveSession(auditId) {
  try { return localStorage.getItem(key(auditId)) || null; } catch { return null; }
}

export function setActiveSession(auditId, sessionId) {
  try {
    if (sessionId) localStorage.setItem(key(auditId), String(sessionId));
    else localStorage.removeItem(key(auditId));
  } catch { /* opslag niet beschikbaar: sessiemodus geldt dan enkel voor deze pagina */ }
}

// Sessies uit het auditplan. primary/related bevatten control-codes zoals in de
// findings-lijst (f.control_id, bv. 'A.5.1'), in normvolgorde.
export async function loadPlanSessions(auditId) {
  const { data } = await api.get(`/api/audits/${auditId}/plan`);
  const code = new Map(data.controls.map(c => [c.id, c.control_id]));
  const inOrder = (ids) => data.controls.filter(c => ids.includes(c.id)).map(c => code.get(c.id));
  return data.items.filter(i => i.kind === 'session').map(i => ({
    ...i,
    id: String(i.id),
    label: [i.code, i.title].filter(Boolean).join(' – '),
    primary: inOrder(i.control_ids),
    related: inOrder(i.related_ids.filter(id => !i.control_ids.includes(id))),
  }));
}

// Findings van een sessie: eerst de hoofdcontrols, dan de raakvlakken
export function sessionFindings(session, findings) {
  const byCode = new Map(findings.map(f => [f.control_id, f]));
  return [
    ...session.primary.map(c => byCode.get(c)).filter(Boolean),
    ...session.related.map(c => byCode.get(c)).filter(Boolean),
  ];
}

// Sessie die nu bezig is (vandaag, tussen start en eind)
export function sessionNow(sessions, now = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const time = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  return sessions.find(s => s.day === today && s.start_time && s.start_time <= time && (!s.end_time || time < s.end_time)) || null;
}
